import { IAuditInfo } from "audit/models";
import { http } from "shared/api/http";

const buildAuditPath = (tenantId: string, organizationId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants/${tenantId}/organizations/${organizationId}/audit`;

export const getAuditInfo = async (tenantId: string, organizationId: string) => {
  if (!tenantId || !organizationId) {
    throw new Error("tenantId and organizationId are required to fetch audit info");
  }

  const res = await http.get<IAuditInfo>(`${buildAuditPath(tenantId, organizationId)}/info`);
  return res?.data;
};
